import Vue from 'vue'

var KonamiCode = function (Vue, options) {
  if (typeof options !== 'undefined' && typeof options.callback !== 'function') {
    return
  }
  const kode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65]
  const length = kode.length
  var pos = 0
  document.addEventListener('keydown', function (event) {
    if (event.keyCode === kode[pos++]) {
      if (length === pos) {
        options.callback()
        pos = 0 // ability to start over
        return false
      }
    } else {
      pos = 0
    }
  }, false)
}

Vue.use(KonamiCode, { callback: function () {
  alert('🎮 SW-4699-5427-7192')
  window.open('https://www.youtube.com/watch?v=cPWBG6_jn4Y')
}
})

export default KonamiCode



// WEBPACK FOOTER //
// ./src/plugins/konami-code.js